import React, { forwardRef } from 'react'

import styles from './styles.module.scss'
import cx from 'classnames'

const Input = forwardRef(
	(
		{ value, id, onChange, onChangeWithTarget, placeholder, type, className, error, onBlur, defaultValue, errorClassName },
		ref,
	) => {
		const onChangeInput = event => {
			const value = event.target.rawValue || event.target.value
			onChange && onChange(value)
			onChangeWithTarget && onChangeWithTarget(event)
		}

		const inputCSS = cx(styles.Input, className)

		return (
			<>
				<input
					id={id}
					ref={ref}
					className={inputCSS}
					value={value}
					onChange={onChangeInput}
					placeholder={placeholder}
					type={type}
					onBlur={onBlur}
					defaultValue={defaultValue}
				/>
				{error && <div className={cx(styles.Input__error, errorClassName)}>{error}</div>}
			</>
		)
	},
)

export default Input
